export default "__VITE_ASSET__BIMt_xeB__"